// extracted by mini-css-extract-plugin
export default {"wrapper":"PhotoUpload--wrapper--e682e3","isDragging":"PhotoUpload--isDragging--88ec04","label":"PhotoUpload--label--5fd95e"};